// Single source of truth for backend URL (set REACT_APP_API_URL on Vercel to your Railway URL, e.g. https://your-app.up.railway.app/api)
const normalizeApiBase = (url) => {
  const trimmed = (url || '').replace(/\/+$/, '');
  if (trimmed.endsWith('/api')) {
    return trimmed;
  }
  return `${trimmed}/api`;
};

export const API_BASE_URL = normalizeApiBase(
  process.env.REACT_APP_API_URL || 'http://localhost:8080/api'
);

export const API_ORIGIN = API_BASE_URL.replace(/\/api$/, '');

export const getImageUrl = (path) => {
  if (!path) return '';

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (path.startsWith('/api/images/')) {
    return `${API_ORIGIN}${path}`;
  }

  if (path.startsWith('api/images/')) {
    return `${API_ORIGIN}/${path}`;
  }

  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/images/${cleanPath}`;
};
